import React, {FC} from 'react';

import {Icon, IconName} from '../../../../libs/shared/ui/src/components/icon/icon';
import {rotate360Animation} from '../../../../libs/shared/ui/src/styles/mixins';
import {styled} from '../../../../libs/shared/ui/src/theme/userThemeProvider';

/*
 * Props.
 */

interface BannerIconProps {
  iconName: IconName;
  shouldRotate?: boolean;
  color?: string;
}

/*
 * Style.
 */

interface BannerIconStyleProps {
  $shouldRotate: boolean;
}
const StyledIconDiv = styled.div<BannerIconStyleProps>`
  grid-area: icon;
  color: ${(p) => p.color ?? p.theme.bannerIcon};
  ${(p) => p.$shouldRotate && rotate360Animation(2)}
`;

/*
 * Component.
 */

export const BannerIcon: FC<BannerIconProps> = ({iconName, shouldRotate}) => (
  <StyledIconDiv $shouldRotate={Boolean(shouldRotate)}>
    <Icon name={iconName} />
  </StyledIconDiv>
);
